module.exports = __webpack_public_path__ + "static/media/FinalPaper.c653fc17.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Media/FinalPaper.pdf
// module id = 259
// module chunks = 0